export enum ActionType {
    Comment = 1,
    Move = 2,
    Merge = 3,
    Add = 4,
    Send = 5,
    UpdateAttribute = 6,
    UpdateWorkflow = 7,
    Create = 8,
    Delete = 9,
    Workflow = 10,
    Process = 11,
    Reminder = 12,
    Clone = 13,
    Archiving = 14,
    Default = 15,
    SendSms = 16,
}
